import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c47640c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "iopcard"
};
const _hoisted_2 = {
  class: "box_conts"
};
import { ref, markRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getDictListApi, deleteDictApi } from "@/service/modules/role";
import dic_dialog from "./components/dic_dialog.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const data_list = ref([]);
    const loading = ref(false);
    const DialogVisible = ref(false);
    const keys = ref("");
    const handleEdit = row => {
      keys.value = row.key;
      DialogVisible.value = true;
    };
    const handleDelete = row => {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "删除分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          deleteDictApi(row.id).then(res => {
            if (res.code == 0) {
              ElMessage.success("删除成功");
              get_list();
            }
          });
        } catch {}
      }).catch(() => {});
    };
    const get_list = async () => {
      loading.value = true;
      let reqdata = {
        page: 1,
        pageSize: 50
      };
      const res = await getDictListApi(reqdata);
      if (res.code == 0) {
        data_list.value = res.data.data;
        loading.value = false;
      }
    };
    get_list();
    async function add_dict() {
      keys.value = "";
      DialogVisible.value = true;
    }
    async function closeDialog() {
      DialogVisible.value = false;
    }
    async function restData() {
      closeDialog();
      get_list();
    }
    // async function changeStatus(row) {
    //   let reqdata = {
    //     id: row.id,
    //     status: row.status,
    //   };
    //   const res = await setDictStatusApi(reqdata);
    //   if (res.code == 0) {
    //     get_list();
    //   }
    // }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("view", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => add_dict())
      }, {
        default: _withCtx(() => [_createTextVNode("新增")]),
        _: 1
      })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "margin-t20",
        data: data_list.value,
        height: "720",
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "name",
          label: "字典名称"
        }), _createVNode(_component_el_table_column, {
          prop: "key",
          label: "字段key"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "字典状态"
        }, {
          default: _withCtx(scope => []),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => handleEdit(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            onClick: $event => handleDelete(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), DialogVisible.value ? (_openBlock(), _createBlock(dic_dialog, {
        key: 0,
        "dialog-visible": DialogVisible.value,
        onCloseDialog: closeDialog,
        keys: keys.value,
        onRestData: restData
      }, null, 8, ["dialog-visible", "keys"])) : _createCommentVNode("", true)]);
    };
  }
});